module.exports = "https://99designs-start-assets.imgix.net/js/8faf05c4e8a9bef166d017961f5ddd0d.png";